export const SETTING_TYPES = {
  'THEME': 2
};

export const DEFAULT_THEME_INDEX = 0;

export const THEME_LIST = [
  {
    'name': 'yellow',
    'code': '#FFCC33',
    'text': '黄',
    'rgb': 'rgb(255, 204, 51)'
  },
  {
    'name': 'pink',
    'code': '#FF00D9',
    'text': 'ピンク',
    'rgb': 'rgb(255, 0, 217)'
  },
  {
    'name': 'red',
    'code': '#FF3F2A',
    'text': '赤',
    'rgb': 'rgb(255, 63, 42)'
  },
  {
    'name': 'green',
    'code': '#39FF00',
    'text': '緑',
    'rgb': 'rgb(57, 255, 0)'
  },
  {
    'name': 'blue',
    'code': '#009BFF',
    'text': '青',
    'rgb': 'rgb(0, 155, 255)'
  }
];
